module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('BillingSupport_Support', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					renewApi: {
						widget: 'Api',
						method: 'User_Cancelation.renew'
					},
					renewConfirmationPopup: {
						widget:'Popup_Common',
						'dialog.width': '600px',
						'widgets.content.template': 'popup_billingInfo_renew_confirm'
					},
					renewSuccessPopup: {
						widget:'Popup_Common',
						'dialog.width': '400px',
						'widgets.content.template': 'popup_billingInfo_renew_success'
					},
					renewErrorPopup: {
						widget:'Popup_Common',
						'dialog.width': '600px',
						'widgets.content.template': 'popup_billingInfo_renew_error'
					},
					
					support: {
						widget: 'Widget',
						embed: {
							widget: '@parent @parent',
							container: '.billing-support-wrapper'
						},
						template: 'billing_support',
						autoRender: true,
						'hooks.onStartRendering': fox.bind(function (argument) {
							this._handleSupportWidgetRendering();
						}, this)
					}
				},

				handleDom: {
					showConfirmationPopup: {
						targetWidget: '#support',
						target: '.renew',
						event: 'click',
						callback: '_showConfirmationPopup'
					},

					renew: {
						targetWidget: '#renewConfirmationPopup #content',
						target: '#ok',
						event: 'click',
						callback: 'renew'
					},

					deleteAccount: {
						targetWidget: '#support',
						target: '.delete-account',
						callback: 'deleteAccount'
					},

					exersizeRights: {
						targetWidget: '#support',
						target: '.exersise-rights',
						callback: 'exersizeRights'
					}
				},
				handleWom: {
					handleApiSuccess: {
						widget: '#renewApi',
						event: ['success', 'failure', 'error'],
						callback: '_handleApiResponse'
					}
				}
				// 'hooks.onStartInit': function () {
				// 	var links = {
				// 		ccbill: 'https://support.ccbill.com/',
				// 		epoch: 'https://epoch.com/ru/billing_support/contact',
				// 		streamate: 'http://www.streamate.com/customer-service/'
				// 	}

				// 	var biller = fox.getEnv('user.biller');
				// 	var link = links[biller];

				//
				// 	if (!biller || !link) {
				// 		return;
				// 	};

				// 	this.setTemplateOptions({
				// 		biller: biller,
				// 		link: link
				// 	});

				//
				// }
			});

			this.callParent('configure', arguments);
		},

		// _handleStartInit: function (argument) {
		// 	var links = {
		// 		ccbill: 'https://support.ccbill.com/',
		// 		epoch: 'https://epoch.com/ru/billing_support/contact',
		// 		streamate: 'http://www.streamate.com/customer-service/'
		// 	}

		// 	var biller = fox.getEnv('user.biller');
		// 	var link = links[biller];

		//
		// 	if (!biller || !link) {
		// 		if (fox.getEnv('user.canceled') === 1) {
		// 			this.registerOptions('#support', {
		// 				templateOptions: {
		// 					canceled: true,
		// 					expireDate: '2015-02-17'
		// 				}
		// 			})
		// 		}

		// 		return;
		// 	};

		// 	this.registerOptions('#support', {
		// 		templateOptions: {
		// 			biller: biller,
		// 			link: link
		// 		}
		// 	})

		// 	//this.wom1('#support').setTemplateOptions();
		// },
		_handleSupportWidgetRendering: function (argument) {
			var links = {
				ccbill: 'https://support.ccbill.com/',
				epoch: 'https://epoch.com/ru/billing_support/contact',
				streamate: 'http://www.streamate.com/customer-service/'
			};

			var biller = fox.getEnv('user.biller');
			var link = links[biller];
			var cancelState = fox.getEnv('user.canceled');


			if (!biller || !link) {
				if (fox.inArray([1, 7], cancelState)) {
					this.setSupportTemplateOptions({
						canceled: true,
						expireDate: fox.getEnv('user.expDate')
					});

					return;
				}

				this.setSupportTemplateOptions({canceled: false});

				return;
			}

			this.setSupportTemplateOptions({
				biller: biller,
				link: link
			});

			// this.registerOptions('#support', {
			// 	templateOptions: {
			// 		biller: biller,
			// 		link: link
			// 	}
			// })
		},
		_showConfirmationPopup: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			this.showConfirmationPopup();
		},

		showConfirmationPopup: function () {
			this.wom1('#renewConfirmationPopup').show();
		},

		showErrorPopup: function (tplOpts) {
			var popup = this.wom1('#renewErrorPopup');

			popup.wom1('#content').setTemplateOptions((tplOpts || {})).render();

			popup.show();
		},

		showSuccessPopup: function () {
			this.wom1('#renewSuccessPopup').show();
		},

		renew: function (btn, alias, w, e) {
			$(btn).prop('disabled', true);
			$(btn).addClass('spin');
			return this.wom1('#renewApi').psend(this.data).then(function (resp) {
				$(btn).prop('disabled', false);
				$(btn).removeClass('spin');
				return true;
			}.bind(this)).catch(function (e) {
				$(btn).prop('disabled', false);
				$(btn).removeClass('spin');
				return e;
			}.bind(this));
		},

		_handleApiResponse: function (obj, w, e) {
			if (e === 'failure' || e === 'error') {
				this.showErrorPopup(obj.answer);

				return;
			}

			this.showSuccessPopup();
			fox.setEnv('user.canceled', 0);
			fox.UserOffer.checkAction('userRenewed');
			this.wom1('#support').render();
		},

		setSupportTemplateOptions: function (opts) {
			this.wom1('#support').setOption('templateOptions', opts);
		},

		deleteAccount: function() {
			console.log('deleteAccount');

			fox.site.rwom1('#gdprDeleteAccount').show().then(function(result) {
				console.log(result);
			}.bind(this));
		},

		exersizeRights: function() {
			console.log('exersizeRights');
			fox.site.rwom1('#gdprRulesActions').show().then(function(result) {
				console.log(result);
			}.bind(this));
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/billingSupport/support.js
// module id = 849
// module chunks = 4